export const COLLECTIONS_CHANGED_EVENT = "ironcrm:collections-changed";

export function dispatchCollectionsChanged() {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new Event(COLLECTIONS_CHANGED_EVENT));
}
